import { createAsyncThunk } from "@reduxjs/toolkit";
import customFetch from "../../util/config/axiosConfig";
import { getDataUserId } from "../../util/manageAuth";
import { CreateGalleryPostRequest, CreateGalleryPostResponse } from "../../types/galleryTypes";
import { GallerySearchParams, GallerySearchResponse } from "../../types/galleryTypes";

export const createGalleryPost = createAsyncThunk<
    CreateGalleryPostResponse,
    Omit<CreateGalleryPostRequest, "userId">,
    { rejectValue: string }
>(
    "gallery/createPost",
    async (body, thunkAPI) => {
        try {
            const userId = getDataUserId();
            if (!userId) throw new Error("User not authenticated");

            const payload: CreateGalleryPostRequest = {
                ...body,
                userId: Number(userId),
            };

            const response = await customFetch.post("/api/gallery", payload);

            let data = response.data;

            if (typeof data?.data === "string") {
                data.data = JSON.parse(data.data);
            }

            return data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(
                error?.message || "Failed to create gallery post"
            );
        }
    }
);

export const fetchGalleryPosts = createAsyncThunk<
    GallerySearchResponse,
    GallerySearchParams | undefined,
    { rejectValue: string }
>(
    "gallery/fetchGalleryPosts",
    async (params, thunkAPI) => {
        try {
            const userId = getDataUserId();
            if (!userId) throw new Error("User not authenticated");

            const page = params?.page ?? 0;
            const size = params?.size ?? 10;

            const response = await customFetch.get(
                "/api/gallery/gallery/search",
                {
                    params: {
                        userId,
                        mediaType: params?.mediaType || "",
                        messageType: params?.messageType || "",
                        templateName: params?.templateName || "",
                        page,
                        size,
                    },
                }
            );

            let payload = response.data;

            if (typeof payload?.data === "string") {
                payload.data = JSON.parse(payload.data);
            }

            return {
                results: payload.data.results,
                page: payload.data.page,
            };
        } catch (error: any) {
            return thunkAPI.rejectWithValue(
                error?.message || "Failed to fetch gallery posts"
            );
        }
    }
);